import { Context, createContext, FC, useCallback, useEffect, useMemo } from 'react';
import { LocalStorageKey } from '@src/core/storage/local';
import { LocalStorageService } from '@src/core/storage/local/local-storage.service';

export const FeatureStorageContext: Context<{
  LocalStorageService: LocalStorageService;
}> = createContext(null);

export const FeatureStorageProvider: FC = (props) => {
  const { children } = props;

  const localStorageServiceInstance = useMemo(() => new LocalStorageService(document), []);

  const cmpEnableErrorNotifier = useCallback(
    (toggle: boolean) => {
      localStorageServiceInstance.setItem(LocalStorageKey.IsErrorNotifierEnabled, toggle);
      return `Storage item "${LocalStorageKey.IsErrorNotifierEnabled}" is set to ${toggle}`;
    },
    [localStorageServiceInstance]
  );

  const cmpEnableSnowAutomationRequestModule = useCallback(
    (toggle: boolean) => {
      localStorageServiceInstance.setItem(
        LocalStorageKey.IsEnableSnowAutomationRequestModule,
        toggle
      );
      return `Storage item "${LocalStorageKey.IsEnableSnowAutomationRequestModule}" is set to ${toggle}`;
    },
    [localStorageServiceInstance]
  );

  useEffect(() => {
    if (window) {
      // @ts-ignore
      window.cmpEnableErrorNotifier = cmpEnableErrorNotifier;

      // @ts-ignore
      window.cmpEnableSnowAutomationRequestModule = cmpEnableSnowAutomationRequestModule;

      // @ts-ignore
    }
  }, [cmpEnableErrorNotifier, cmpEnableSnowAutomationRequestModule]);

  return (
    <FeatureStorageContext.Provider
      value={{
        LocalStorageService: localStorageServiceInstance,
      }}
    >
      {children && children}
    </FeatureStorageContext.Provider>
  );
};
